import { Application, PayPeriodTypes, UpdateEmploymentInput, UpdateEmploymentResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';
import getApplicationId from '../../utils/commonState/getApplicationId';

export interface PayFrequencyModel {
  paymentFrequency: PayPeriodTypes;
  nextPayDate?: string;
  lastPayDate: string;
  isPaidViaDirectDeposit?: boolean;
}

const updateEmployment = async (application: Application | undefined, employmentData: PayFrequencyModel): Promise<UpdateEmploymentResponse | undefined> => {
  const employmentInfo: UpdateEmploymentInput = {
    isPaidViaDirectDeposit: employmentData.isPaidViaDirectDeposit ?? false,
    lastPayDate: employmentData.lastPayDate,
    nextPayDate: employmentData?.nextPayDate,
    paymentFrequency: employmentData.paymentFrequency!,
    applicationId: getApplicationId(application),
  };

  try {
    const { data } = await applicationFormService.updateEmployment(employmentInfo);
    return data?.updateEmployment as UpdateEmploymentResponse;
  } catch (err: any) {
    const error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
        break;
    }
    throw error;
  }
};

export default updateEmployment;
